import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useMcsContext } from "../MCS.context";
import { secondAxios } from "../../../../../../api/axios";
import { lightTable } from "../../../../../../styles/muiProps";
import { schedule4DColumns } from "./columns";

export default function Schedule4D() {
  const { plant } = useMcsContext();
  const [materials, setMaterials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMaterials = async () => {
      if (!plant?.id) return;

      try {
        setLoading(true);
        // Fetch all materials from all drawings for the plant
        const response = await secondAxios.get(`/material/plant/${plant.id}`);
        
        // The API might return materials directly or grouped by drawing
        // Handle both cases
        const allMaterials = [];
        
        if (response.data && Array.isArray(response.data)) {
          response.data.forEach((item) => {
            // If item has materials array, it's a drawing
            if (item.materials && Array.isArray(item.materials)) {
              item.materials.forEach((material) => {
                allMaterials.push({
                  ...material,
                  drawing: {
                    id: item.id,
                    title: item.title,
                    dwgNumber: item.dwgNumber,
                    revision: item.revision,
                    sheetNumber: item.sheetNumber,
                  },
                });
              });
            } 
            // If item doesn't have materials but has drawing info, it might be a material with drawing reference
            else if (item.drawing || item.drawingId) {
              allMaterials.push(item);
            }
            // Otherwise, treat as a material
            else {
              allMaterials.push(item);
            }
          });
        }
        
        setMaterials(allMaterials);
      } catch (error) {
        console.error("Error fetching materials:", error);
        // Fallback: try to get materials from plant.drawings if available
        if (plant.drawings && Array.isArray(plant.drawings)) {
          const allMaterials = [];
          plant.drawings.forEach((drawing) => {
            if (drawing.materials && Array.isArray(drawing.materials)) {
              drawing.materials.forEach((material) => {
                allMaterials.push({
                  ...material,
                  drawing: {
                    id: drawing.id,
                    title: drawing.title,
                    dwgNumber: drawing.dwgNumber,
                    revision: drawing.revision,
                    sheetNumber: drawing.sheetNumber,
                  },
                });
              });
            }
          });
          setMaterials(allMaterials);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchMaterials();
  }, [plant?.id]);

  const table = useMaterialReactTable({
    data: materials,
    columns: schedule4DColumns,
    initialState: {
      sorting: [{ id: "drawingTitle", desc: false }],
    },
    ...lightTable,
    enableStickyHeader: true,
    enableEditing: true,
    editDisplayMode: "row",
    enableRowActions: true,
    positionActionsColumn: "last",
    muiTableContainerProps: { sx: { maxHeight: "600px" } },
    onEditingRowSave: async ({ values, table, row }) => {
      // Handle save logic here
      // You can update the material data or make an API call
      console.log("Saving row:", values);
      // Update local state
      const updatedMaterials = [...materials];
      const index = updatedMaterials.findIndex((m) => m.id === row.original.id);
      if (index !== -1) {
        updatedMaterials[index] = { ...updatedMaterials[index], ...values };
        setMaterials(updatedMaterials);
      }
      table.setEditingRow(null);
    },
  });

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        Loading materials...
      </Box>
    );
  }

  return <MaterialReactTable table={table} />;
}

